export const usersSelector = state => state.entities.users;
export const carriersSelector = state => state.entities.carriers;
export const deliveriesSelector = state => state.entities.deliveries;
export const locationsSelector = state => state.entities.locations;
